<template>
  <div class="carrossel-step-conteudo-vitrine">
    <h3 class="step-title">Conteúdo</h3>
    <p class="step-subtitle">
      Defina o tipo de vitrine e a categoria de produtos exibida.
    </p>

    <v-divider class="mb-5" />

    <v-row>
      <v-col cols="12" md="6">
        <label class="field-label">Tipo de vitrine</label>
        <FormAutocomplete
          v-model="wizardState.conteudoState.tipoCarrosselSelecionado"
          placeholder="Selecione sua vitrine"
          :options="tiposCarrosseis"
          chips
          :validation="$v.wizardState.conteudoState.tipoCarrosselSelecionado"
        />
        <small class="field-hint">
          Escolha como os produtos serão selecionados para exibição.
        </small>
      </v-col>

      <v-col v-if="showCategoriaField" cols="12" md="6">
        <label class="field-label">Categoria de produtos</label>
        <FormAutocomplete
          v-model="wizardState.conteudoState.categoriaSelecionada"
          placeholder="Selecione sua categoria"
          :options="categoriaOptions"
          chips
          :validation="$v.wizardState.conteudoState.categoriaSelecionada"
        />
        <small class="field-hint">
          Produtos desta categoria serão exibidos na vitrine.
        </small>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FormAutocomplete from "@/components/form/FormAutocomplete";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import {
  createEmptyConteudoState,
  getCategoriaOptions,
  getCarouselTypeValue,
  getTiposCarrosseis,
  isCarrosselListaCompras,
  isCarrosselProdutos,
  isCarrosselProdutosCliente,
  syncConteudoToCarrossel,
  validateStepConteudo
} from "../../utils/utilCarrossel";

export default {
  name: "CarrosselStepConteudoVitrine",
  components: {
    FormAutocomplete
  },
  props: {
    wizardState: {
      type: Object,
      required: true
    },
    setoresFolha: {
      type: Array,
      default: () => []
    },
    showComponente: {
      type: Function,
      required: true
    },
    carouselTypeVariant: {
      type: String,
      default: "type1"
    }
  },
  created() {
    if (!this.wizardState.conteudoState) {
      this.$set(this.wizardState, "conteudoState", createEmptyConteudoState());
    }
  },
  validations() {
    return {
      wizardState: {
        conteudoState: {
          tipoCarrosselSelecionado: {
            required(value) {
              return !!getCarouselTypeValue(value);
            }
          },
          categoriaSelecionada: {
            required(value) {
              if (!this.showCategoriaField || !this.exigeCategoria) {
                return true;
              }
              return !!getCarouselTypeValue(value);
            }
          }
        }
      }
    };
  },
  computed: {
    tiposCarrosseis() {
      const showCommerce = this.showComponente([
        ModulesEnum.COMMERCE_APP,
        ModulesEnum.WEB_COMMERCE
      ]);
      return getTiposCarrosseis(showCommerce, this.carouselTypeVariant);
    },
    categoriaOptions() {
      return getCategoriaOptions(this.setoresFolha);
    },
    carouselTypeValue() {
      return getCarouselTypeValue(
        this.wizardState.conteudoState?.tipoCarrosselSelecionado
      );
    },
    showCategoriaField() {
      return (
        isCarrosselProdutos(this.carouselTypeValue) &&
        !isCarrosselListaCompras(this.carouselTypeValue) &&
        this.showComponente([
          ModulesEnum.COMMERCE_APP,
          ModulesEnum.WEB_COMMERCE,
          ModulesEnum.ORCAMENTO_WEB,
          ModulesEnum.ORCAMENTO_APP,
          ModulesEnum.PORTFOLIO_WEB
        ])
      );
    },
    exigeCategoria() {
      return (
        isCarrosselProdutos(this.carouselTypeValue) &&
        !isCarrosselProdutosCliente(this.carouselTypeValue) &&
        this.showComponente([
          ModulesEnum.COMMERCE_APP,
          ModulesEnum.WEB_COMMERCE,
          ModulesEnum.ORCAMENTO_WEB,
          ModulesEnum.ORCAMENTO_APP
        ])
      );
    }
  },
  watch: {
    "wizardState.conteudoState.tipoCarrosselSelecionado": {
      deep: true,
      handler() {
        if (!this.showCategoriaField) {
          this.wizardState.conteudoState.categoriaSelecionada = null;
          this.$v.wizardState.conteudoState.categoriaSelecionada.$reset();
        }
        this.$emit("dirty");
      }
    },
    "wizardState.conteudoState.categoriaSelecionada": {
      deep: true,
      handler() {
        this.$emit("dirty");
      }
    }
  },
  methods: {
    validate() {
      const utilResult = validateStepConteudo(this.wizardState.conteudoState, {
        showComponente: this.showComponente
      });

      this.$v.$touch();

      if (!utilResult.valid) {
        this.$vueOnToast.pop("warning", utilResult.message);
        return false;
      }

      if (!this.$v.$invalid) {
        return true;
      }

      if (this.$v.wizardState.conteudoState.tipoCarrosselSelecionado.$invalid) {
        this.$vueOnToast.pop("warning", "Selecione o tipo de vitrine");
      } else if (
        this.$v.wizardState.conteudoState.categoriaSelecionada.$invalid
      ) {
        this.$vueOnToast.pop(
          "warning",
          "Vincule essa vitrine de produtos à uma categoria"
        );
      }

      return false;
    },
    syncToCarrossel() {
      syncConteudoToCarrossel(this.wizardState);
    }
  }
};
</script>

<style scoped>
.step-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
  text-align: left;
}

.step-subtitle {
  color: #666;
  margin-bottom: 24px;
  text-align: left;
}

.field-label {
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
  margin-left: 10px;
  text-align: left;
  width: 100%;
}

.field-hint {
  display: block;
  color: #888;
  font-size: 12px;
  margin-top: -8px;
  margin-left: 10px;
  margin-bottom: 10px;
  text-align: left;
}
</style>
